import type { Row, Table as ITable } from "@tanstack/react-table";
import { ReactNode } from "react";
import { cx } from "shared/utils";

export const ExpandedRow = ({
  table,
  rowId,
  expandedRenderer,
  row,
  isCustomExpandedRow,
  isExpanded
}: {
  row: Row<any>;
  table: ITable<any>;
  rowId: string;
  expandedRenderer?: (row: Row<unknown>) => ReactNode;
  isExpanded: boolean;
  isCustomExpandedRow?: boolean;
}) => {
  if (!expandedRenderer) return null;

  if (isCustomExpandedRow) return expandedRenderer(row);

  return (
    <tr
      key={`row_${rowId}_expanded`}
      className={cx(
        "border-b border-b-alpha-40 bg-background-900 last-of-type:border-b-0 ",
        isExpanded ? "table-row" : "hidden print:table-row"
      )}
    >
      {/* Not ideal. No guaranty this is gonna be first row group */}
      <td
        className="border-0 border-hidden"
        colSpan={table.getHeaderGroups()[0].headers.length || 1}
      >
        {expandedRenderer(row)}
      </td>
    </tr>
  );
};
